import { useState, useEffect } from 'react';
import { checkTwoFactorAuthState } from '../api/users.js';

export const useTwoFactorAuth = () => {
  const [isValidating, setIsValidating] = useState(true);
  const [authState, setAuthState] = useState(null);
  const [recoveryCodes, setRecoveryCodes] = useState(null);
  const [completedUser, setCompletedUser] = useState(null);

  useEffect(() => {
    checkTwoFactorAuthState()
      .then((result) => {
        setAuthState(result.success ? result : { success: false });
        setIsValidating(false);
      })
      .catch(() => {
        setAuthState({ success: false });
        setIsValidating(false);
      });
  }, []);

  const handleRegistrationComplete = (result) => {
    if (result.recovery_codes && result.recovery_codes.length > 0) {
      setRecoveryCodes(result.recovery_codes);
      setCompletedUser(result.user);
      setAuthState({
        success: true,
        required_action: 'show_recovery_codes',
      });
    } else {
      setAuthState((prev) => ({ ...prev, required_action: 'verify' }));
    }
  };

  const updateAuthState = (updates) => {
    setAuthState((prev) => ({ ...prev, ...updates }));
  };

  const clearRecoveryData = () => {
    setRecoveryCodes(null);
    setCompletedUser(null);
  };

  return {
    isValidating,
    authState,
    recoveryCodes,
    completedUser,
    handleRegistrationComplete,
    updateAuthState,
    clearRecoveryData,
  };
};
